import React, { Fragment, useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import dayjs from "dayjs";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Table,
  Select,
  Progress,
  Tooltip,
  Spin,
  Dropdown,
  Tag,
  Checkbox,
  Drawer,
  Switch,
  DatePicker,
  Button,
  notification,
} from "antd";
import "./style.scss";
import H3Text from "@Uilib/h3Text";
import Helpers from "@Apis/helpers";
import SelectDepartment from "@Components/Common/SelectDepartment";
import { toISTDate } from "@Apis/constants";
import TagSelector from "@Components/Common/Selector/TagSelector";
import PurchaseOrderActions from "@Actions/purchaseOrderActions";
import { LoadingOutlined } from "@ant-design/icons";
import H3Image from "@Uilib/h3Image";
import closeIcon from "@Images/icons/icon-close-blue.png";
import ViewPurchaseOrder from "@Components/Common/ViewPurchaseOrder";
import MrpV2Actions from "@Actions/production/mrpV2Actions";
import H3DateSelector from "@Uilib/h3DateSelector";
import searchIcon from "@Images/icons/icon-search.png";
import MrpV2Reducers from "../../../../../../reducers/production/mrpV2Reducers";
import { GetPurchaseOrders } from '@Modules/purchase/purchaseOrder';

const { Option } = Select;

const LinkPurchaseOrderMrp = ({
  user,
  history,
  mrpId,
  getMOLoading,
  linkMoToMrp,
  linkMoToMrpLoading,
  tenantId,
  callback,
  MONEY,
  mrpData,
  getPurchaseOrderByIdLoading,
  getPurchaseOrderById,
  getPurchaseOrdersV2,
  getPurchaseOrdersV2Loading,
  getStockItems,
  linkPoToMrp,
  linkPoToMrpLoading,
  materialShortage,
}) => {
  const [showLinkPoMrp, setShowLinkPoMrp] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState(null);
  const [poData, setPoData] = useState([]);
  const [call, setCall] = useState(false);
  const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState("");
  const [selectedTag, setSelectedTag] = useState([]);
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null);
  const [showPurchaseOrder, setShowPurchaseOrder] = useState(false);
  const [startDateMomentEpoch, setStartDateMomentEpoch] = useState("");
  const [endDateMomentEpoch, setEndDateMomentEpoch] = useState("");
  const [keyword, setKeyword] = useState("");
  const [disabledDepartmentSelection, setDisabledDepartmentSelection] =
    useState(false);

  useEffect(() => {
    if (mrpData?.departments) {
      setSelectedDepartment(
        mrpData?.departments?.map((department) => department?.department_id)
      );
      setDisabledDepartmentSelection(true);
    } else {
      setSelectedDepartment([]);
      setDisabledDepartmentSelection(false);
    }
  }, [mrpData]);
  useEffect(() => {
    if (mrpData?.departments) {
      setSelectedDepartment(
        mrpData?.departments?.map((department) => department?.department_id)
      );
      setDisabledDepartmentSelection(true);
    } else {
      setSelectedDepartment([]);
      setDisabledDepartmentSelection(false);
    }
    // getPurchaseOrders(
    //   user?.tenant_info?.org_id,
    //   mrpData?.tenant_id,
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   "ISSUED",
    //   1,
    //   100,
    //   null,
    //   (purchase_orders) => {
    //     setPoData(purchase_orders.purchase_order);
    //   },
    //   null,
    //   null,
    //   "NOT_RECEIVED,PARTIALLY_RECEIVED",
    //   null,
    //   null,
    //   null,
    //   null,
    //   materialShortage?.length
    //     ? materialShortage?.map((ms) => ms.product_sku_id).join(",")
    //     : null,
    //   null,
    //   null,
    //   mrpData?.departments?.length
    //     ? mrpData?.departments
    //       ?.map((department) => department.department_id)
    //       .join(",")
    //     : null,
    //   true
    // );
    getPurchaseOrdersV2({
      query: {
        org_id: user?.org_id,
        tenant_id: mrpData?.tenant_id,
        status: "ISSUED",
        page: 1,
        limit: 100,
        po_receiving_status: "NOT_RECEIVED,PARTIALLY_RECEIVED",
        product_sku_ids: materialShortage ? materialShortage.map((ms) => ms.product_sku_id).join(",") : null,
        department_ids: mrpData?.departments?.length ? mrpData?.departments.map((department) => department.department_id).join(",") : null,
        exclude_mrp_linked: true,
      },
    }, (purchase_orders) => {
      setPoData(purchase_orders.purchase_order);
    });
  }, []);

  const handleSearchPo = () => {
    // getPurchaseOrders(
    //   user?.tenant_info?.org_id,
    //   mrpData?.tenant_id,
    //   null,
    //   null,
    //   null,
    //   startDateMomentEpoch || null,
    //   endDateMomentEpoch || null,
    //   "ISSUED",
    //   1,
    //   100,
    //   null,
    //   (purchase_orders) => {
    //     setPoData(purchase_orders.purchase_order);
    //   },
    //   null,
    //   keyword || null,
    //   "NOT_RECEIVED,PARTIALLY_RECEIVED",
    //   null,
    //   null,
    //   null,
    //   estimatedDeliveryDate
    //     ? dayjs(estimatedDeliveryDate).format("YYYY-MM-DD")
    //     : null,
    //   materialShortage
    //     ? materialShortage.map((ms) => ms.product_sku_id).join(",")
    //     : null,
    //   null,
    //   selectedTag?.length ? selectedTag?.join(",") : null,
    //   selectedDepartment?.length ? selectedDepartment.join(",") : null,
    //   true
    // );
    getPurchaseOrdersV2({
      query: {
        org_id: user?.org_id,
        tenant_id: mrpData?.tenant_id,
        from_date: startDateMomentEpoch,
        to_date: endDateMomentEpoch,
        search_keyword: keyword,
        edd: estimatedDeliveryDate
          ? dayjs(estimatedDeliveryDate).format("YYYY-MM-DD")
          : null,
        status: "ISSUED",
        page: 1,
        limit: 100,
        po_receiving_status: "NOT_RECEIVED,PARTIALLY_RECEIVED",
        product_sku_ids: materialShortage ? materialShortage.map((ms) => ms.product_sku_id).join(",") : null,
        tags: selectedTag?.length ? selectedTag?.join(",") : null,
        department_ids: mrpData?.departments?.length ? mrpData?.departments.map((department) => department.department_id).join(",") : null,
        exclude_mrp_linked: true,
      },
    }, (purchase_orders) => {
      setPoData(purchase_orders.purchase_order);
    });
  };

  const getPoColumns = () => {
    const poListColumns = [
      {
        title: "",
        render: (record) => (
          <Link to={`/approval?type=po&id=${record.po_id}`}>
            <div className="mobile-list__item">
              <div style={{ display: "flex" }}>
                <H3Text
                  text={`#${record?.po_number}`}
                  className="mobile-list__item-number"
                />
                <div
                  className="mobile-list__item-status"
                  style={{
                    backgroundColor: Helpers.getStatusColor(record.status)
                      .color,
                  }}
                >
                  {Helpers.getStatusColor(record.status).text?.toUpperCase()}
                </div>
              </div>
              {record?.seller_info && (
                <div className="mobile-list__item-info">
                  {`Vendor - ${record.seller_info?.seller_name}`}
                </div>
              )}
              <H3Text
                text={`Amount - ${MONEY(record?.po_grand_total || "0", record?.org_currency_info?.currency_code)}`}
                className="mobile-list__item-info"
              />
              <H3Text
                text={
                  <React.Fragment>
                    Receiving Status -&nbsp;
                    <span
                      style={{
                        color: Helpers.getStatusColor(
                          record?.po_receiving_status || "NOT_RECEIVED"
                        ).color,
                      }}
                    >
                      {Helpers.getStatusColor(
                        record?.po_receiving_status || "NOT_RECEIVED"
                      ).text?.toUpperCase()}
                    </span>
                  </React.Fragment>
                }
                className="mobile-list__item-info"
              />
              <H3Text
                text={`Created by ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : "Unknown"} on ${toISTDate(record?.created_at).format("DD/MM/YYYY")}`}
                className="mobile-list__item-footer"
              />
            </div>
          </Link>
        ),
        responsive: ["xs"],
      },
      {
        title: "Purchase Order#",
        dataIndex: "po_number",
        render: (text, record) => (
          <div className="list__actions">
            <Link to={`/approval?type=po&id=${record.po_id}`}>
              <div className=" list__actions-button">{record?.po_number}</div>
            </Link>
          </div>
        ),
        fixed: "left",
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Vendor",
        render: (text, record) => (
          <Fragment>
            <div
              style={{
                color: "rgb(106, 106, 106)",
                fontWeight: "600",
                fontSize: "12px",
                cursor: "pointer",
              }}
            />
            <div
              style={{
                color: "#2D7DF7",
                fontWeight: "600",
                fontSize: "12px",
                cursor: "pointer",
              }}
              onClick={() =>
                history.push(`/vendors/view/${record?.seller_info?.seller_id}`)
              }
            >
              {record && record.seller_info
                ? `${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ""}${record.seller_info?.seller_name}`?.trim()
                : ""}
            </div>
            <div>
              {record?.seller_address?.city ? record.seller_address.city : ""}
            </div>
          </Fragment>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Items",
        render: (text, record) => record.purchase_order_lines?.length,
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Amount",
        render: (text, record) =>
          MONEY(
            record.po_grand_total || "0",
            record?.org_currency_info?.currency_code
          ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Created Date",
        render: (text, record) => (
          <div>
            {toISTDate(record?.created_at).format("DD/MM/YYYY")}
            <H3Text
              text={
                record?.created_by_info
                  ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}`
                  : "Unknown"
              }
              className="table-subscript"
            />
          </div>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "PO Date",
        render: (text, record) => (
          <div>{toISTDate(record?.po_date).format("DD/MM/YYYY")}</div>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Status",
        render: (item) => (
          <div
            className="qr__status"
            style={{
              backgroundColor: Helpers.getStatusColor(item.status).color,
            }}
          >
            {Helpers.getStatusColor(item.status).text}
          </div>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Receiving Status",
        render: (item) => (
          <Fragment>
            <div
              style={{
                color: Helpers.getStatusColor(
                  item?.po_receiving_status || "NOT_RECEIVED"
                ).color,
              }}
            >
              {Helpers.getStatusColor(
                item?.po_receiving_status || "NOT_RECEIVED"
              ).text?.toUpperCase()}
            </div>
            {item?.closing_status === "CLOSED" && (
              <div className="po-short-closed-tag">Closed</div>
            )}
          </Fragment>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "",
        key: "action",
        render: (text, record) => (
          <div className="list__actions">
            <div
              className="list__actions-button list__actions-button-dark"
              style={{ width: "70px", whiteSpace: "nowrap" }}
              onClick={() => {
                setSelectedPurchaseOrder(record?.po_id);
                if (!getPurchaseOrderByIdLoading) {
                  getPurchaseOrderById(record?.po_id, record?.tenant_id, () => {
                    setShowPurchaseOrder(true);
                  });
                }
              }}
            >
              {getPurchaseOrderByIdLoading &&
              selectedPurchaseOrder === record?.po_id ? (
                <LoadingOutlined />
              ) : (
                "View"
              )}
            </div>
          </div>
        ),
        fixed: "right",
        responsive: ["sm", "md", "lg", "xxl"],
        className: "list__actions-column",
      },
    ];
    return poListColumns;
  };

  return (
    <Spin spinning={getMOLoading === true}>
      <div className="link-po-mrp__wrapper">
        <div className="link-po-mrp__filter-wrapper">
          <div className="ant-row">
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">Search</label>
                <div className="section-search">
                  <div className="section-search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Purchase Order..."
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            setKeyword(e.target.value);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setKeyword(keyword);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">Department</label>
                <SelectDepartment
                  title="Select Department"
                  hideTitle
                  selectedDepartment={selectedDepartment}
                  noDropdownAlign
                  onChange={(value) => {
                    setSelectedDepartment(value);
                  }}
                  isMultiple
                  customStyle={{
                    borderRadius: "4px",
                    width: "100%",
                    fontSize: "13px",
                    border: "1px solid rgba(68, 130, 218, 0.2)",
                  }}
                  disabled={disabledDepartmentSelection}
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">Estimated Delivery Date</label>
                <DatePicker
                  value={estimatedDeliveryDate}
                  onChange={(value) => {
                    setEstimatedDeliveryDate(value);
                  }}
                  style={{
                    width: "100%",
                    borderRadius: "2px",
                    border: "1px solid rgba(68, 130, 218, 0.2)",
                  }}
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">Select Labels</label>
                <TagSelector
                  filter
                  entityType="PURCHASE_ORDER"
                  selectedTags={selectedTag}
                  showSearch
                  showAll={false}
                  noDropdownAlign
                  isMultiple
                  onChange={(value) => {
                    setSelectedTag(value);
                  }}
                  placeholder="Select Label"
                  hideTitle
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer product-form__right-input">
                <label className="orgFormLabel">Date</label>
                <H3DateSelector
                  customStyle={{
                    borderRadius: "3px",
                    width: "100%",
                    marginTop: "-7px",
                    height: "32px",
                  }}
                  startDate={startDateMomentEpoch}
                  endDate={endDateMomentEpoch}
                  onDateChange={(date) => {
                    if (date?.length === 2) {
                      setStartDateMomentEpoch(
                        dayjs(date[0])?.startOf("day").valueOf()
                      );
                      setEndDateMomentEpoch(
                        dayjs(date[1])?.endOf("day").valueOf()
                      );
                    } else {
                      setStartDateMomentEpoch(null);
                      setEndDateMomentEpoch(null);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <Button
          onClick={() => {
            handleSearchPo();
          }}
        >
          Search
        </Button>
        <div className="link-po-mrp__table-wrapper">
          <Table
            title={() => (
              <div className="link-po-mrp__table-title">
                <H3Text
                  text={`${poData?.length || 0} Purchase Orders`}
                  className=""
                />
              </div>
            )}
            bordered
            showHeader
            size="small"
            loading={getPurchaseOrdersV2Loading || linkPoToMrpLoading}
            columns={getPoColumns()}
            dataSource={poData || []}
            scroll={{ x: "max-content" }}
            pagination={false}
            rowKey="po_id"
            rowSelection={
              window.screen.width > 425
                ? {
                    onChange: (rowKeys, rows) => {
                      setSelectedRowKeys(rowKeys);
                      setSelectedRows(rows);
                    },
                    selectedRowKeys,
                  }
                : false
            }
          />
        </div>
      </div>
      <div className="custom-drawer__footer" style={{ width: "100%" }}>
        <div className="ant-col-md-6">
          <Button
            type="primary"
            onClick={() => {
              if (selectedRows?.length > 0) {
                linkPoToMrp(
                  {
                    po_ids: selectedRowKeys,
                    mrp_id: mrpId,
                  },
                  () => {
                    setSelectedRowKeys(null);
                    setSelectedRows(null);
                    callback();
                  }
                );
              } else {
                notification.open({
                  type: "error",
                  message: "Please select at least one purchase order.",
                  placement: "top",
                  duration: 4,
                });
              }
            }}
            loading={linkPoToMrpLoading}
            disabled={linkPoToMrpLoading}
          >
            Link Purchase Orders
          </Button>
        </div>
      </div>
      <Drawer
        onClose={() => {
          setShowPurchaseOrder(false);
          callback();
        }}
        open={showPurchaseOrder}
        width="1140px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: "1095px" }}>
            <H3Text
              text="View Purchase Order"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowPurchaseOrder(false);
                callback();
              }}
            />
          </div>
        </div>
        <ViewPurchaseOrder
          isQuickView
          selectedPurchaseOrder={selectedPurchaseOrder}
          handleClose={() => {
            setShowPurchaseOrder(false);
          }}
        />
      </Drawer>
    </Spin>
  );
};
const mapStateToProps = ({
  UserReducers,
  DepartmentReducers,
  PurchaseOrderReducers,
  MrpV2Reducers,
  GetPurchaseOrders,
}) => ({
  user: UserReducers.user,
  departments: DepartmentReducers.departments,
  getPurchaseOrderByIdLoading:
    PurchaseOrderReducers.getPurchaseOrderByIdLoading,
  linkPoToMrpLoading: MrpV2Reducers.linkPoToMrpLoading,
  MONEY: UserReducers.MONEY,
  purchaseOrdersV2: GetPurchaseOrders.data,
  getPurchaseOrdersV2Loading: GetPurchaseOrders.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getPurchaseOrderById: (poId, tenantId, callback) =>
    dispatch(
      PurchaseOrderActions.getPurchaseOrderById(poId, tenantId, callback)
    ),
  getStockItems: (payload, callback) =>
    dispatch(MrpV2Actions.getStockItems(payload, callback)),
  linkPoToMrp: (payload, callback) =>
    dispatch(MrpV2Actions.linkPoToMrp(payload, callback)),
  getPurchaseOrdersV2: (payload, callback) => dispatch(GetPurchaseOrders.actions.request(payload, callback)),
});

LinkPurchaseOrderMrp.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  mrpId: PropTypes.any,
  callback: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LinkPurchaseOrderMrp));
